import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function TokenPage() {
  const { api } = useAuth();
  const [balance, setBalance] = useState(0);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get('/token/balance').then(r => {
      setBalance(r.data.tokens);
      setHistory(r.data.history || []);
    });
  }, [api]);

  const charge = async (packageId) => {
    if (loading) return;
    setLoading(true);
    try {
      const r = await api.post('/token/charge', { packageId });
      setBalance(r.data.balance);
      alert(`충전 완료! 잔액: ${r.data.balance.toLocaleString()}토큰`);
      // 내역 새로고침
      const br = await api.get('/token/balance');
      setHistory(br.data.history || []);
    } catch (e) {
      alert('충전 실패: ' + (e.response?.data?.error || e.message));
    }
    setLoading(false);
  };

  const PACKAGES = [
    { id: 'basic', name: '베이직', price: '55,000', tokens: '1,000', bonus: '' },
    { id: 'pro', name: '프로', price: '75,000', tokens: '1,500', bonus: '9% 보너스', hot: true },
    { id: 'premium', name: '프리미엄', price: '100,000', tokens: '2,200', bonus: '20% 보너스' },
  ];

  return (
    <div style={{ padding: 32, maxWidth: 900, margin: '0 auto' }}>
      {/* 잔액 */}
      <div style={{ background: '#161B22', borderRadius: 16, border: '1px solid rgba(0,229,255,0.2)', padding: 32, marginBottom: 32, textAlign: 'center' }}>
        <div style={{ fontSize: 14, color: '#6B7280', marginBottom: 8 }}>현재 보유 토큰</div>
        <div style={{ fontSize: 56, fontWeight: 800, color: '#00F0FF', fontFamily: 'monospace' }}>
          🪙 {balance.toLocaleString()}
        </div>
        <div style={{ fontSize: 13, color: '#6B7280', marginTop: 8 }}>
          ≈ {(balance * 55).toLocaleString()}원 상당
        </div>
      </div>

      {/* 패키지 */}
      <h3 style={{ color: '#E6EDF3', marginBottom: 20 }}>토큰 충전</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 40 }}>
        {PACKAGES.map(pkg => (
          <div key={pkg.id} style={{
            padding: 28, borderRadius: 16, border: `1px solid ${pkg.hot ? 'rgba(0,229,255,0.3)' : '#2A3441'}`,
            background: pkg.hot ? 'rgba(0,229,255,0.04)' : '#161B22',
            position: 'relative', textAlign: 'center',
          }}>
            {pkg.hot && (
              <div style={{ position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)', background: '#00F0FF', color: '#000', padding: '3px 16px', borderRadius: 100, fontSize: 11, fontWeight: 800, whiteSpace: 'nowrap' }}>
                🔥 가장 인기
              </div>
            )}
            <div style={{ fontSize: 20, fontWeight: 800, color: '#E6EDF3', marginBottom: 6 }}>{pkg.name}</div>
            <div style={{ fontSize: 40, fontWeight: 800, color: '#00F0FF', marginBottom: 4 }}>{pkg.tokens}</div>
            <div style={{ fontSize: 13, color: '#4ADE80', fontWeight: 600, marginBottom: 16 }}>토큰 {pkg.bonus && `(${pkg.bonus})`}</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: '#E6EDF3', marginBottom: 20 }}>{pkg.price}원</div>
            <button onClick={() => charge(pkg.id)} disabled={loading}
              style={{ width: '100%', padding: '12px', borderRadius: 10, border: 'none', background: pkg.hot ? '#00F0FF' : '#2A3441', color: pkg.hot ? '#000' : '#E6EDF3', fontWeight: 700, fontSize: 14, cursor: 'pointer', fontFamily: "'Noto Sans KR', sans-serif" }}>
              충전하기
            </button>
          </div>
        ))}
      </div>

      {/* 토큰 소비 안내 */}
      <h3 style={{ color: '#E6EDF3', marginBottom: 16 }}>토큰 소비 안내</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 10, marginBottom: 40 }}>
        {[
          ['🎙️ STT 추출', '2토큰/분', false],
          ['✂️ 1차 영상 생성', '80토큰/개', false],
          ['⚡ 숏폼 AI 분석', '150토큰/회', false],
          ['🎬 숏폼 영상 생성', '80토큰/개', false],
          ['📝 대본 생성', '50토큰/개', false],
          ['🔍 Gemini 분석', '100토큰/회', true],
          ['🎞️ 최종 영상 생성', '80토큰/개', true],
        ].map(([action, cost, soon]) => (
          <div key={action} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', background: '#161B22', borderRadius: 10, border: '1px solid #2A3441', fontSize: 14, ...(soon ? {opacity:0.45} : {}) }}>
            <span style={{ color: '#C9D1D9' }}>{action}</span>
            {soon
              ? <span style={{ padding: '2px 10px', borderRadius: 100, fontSize: 11, fontWeight: 700, background: 'rgba(255,184,0,0.15)', color: '#FFB800', border: '1px solid rgba(255,184,0,0.3)' }}>준비 중</span>
              : <span style={{ color: '#00F0FF', fontWeight: 700 }}>{cost}</span>
            }
          </div>
        ))}
      </div>

      {/* 사용 내역 */}
      <h3 style={{ color: '#E6EDF3', marginBottom: 16 }}>최근 사용 내역</h3>
      <div style={{ background: '#161B22', borderRadius: 12, border: '1px solid #2A3441', overflow: 'hidden' }}>
        {history.length === 0 ? (
          <div style={{ padding: 24, textAlign: 'center', color: '#6B7280', fontSize: 14 }}>사용 내역이 없습니다</div>
        ) : history.map((h, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: i < history.length-1 ? '1px solid #2A344133' : 'none' }}>
            <div>
              <div style={{ fontSize: 14, color: '#C9D1D9' }}>{h.description}</div>
              <div style={{ fontSize: 11, color: '#6B7280', marginTop: 2 }}>{new Date(h.createdAt).toLocaleString('ko-KR')}</div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 15, fontWeight: 700, color: h.amount > 0 ? '#4ADE80' : '#F44336' }}>
                {h.amount > 0 ? '+' : ''}{h.amount.toLocaleString()}
              </div>
              <div style={{ fontSize: 11, color: '#6B7280' }}>잔액 {h.balance?.toLocaleString()}</div>
            </div>
          </div>
        ))}
      </div>

      <p style={{ marginTop: 20, fontSize: 12, color: '#6B7280', textAlign: 'center' }}>
        미사용 토큰은 영구 이월됩니다 · 충전 후 환불 불가
      </p>

      <div style={{ marginTop: 32, padding: 20, background: '#161B22', borderRadius: 12, border: '1px solid #2A3441' }}>
        <h4 style={{ color: '#E6EDF3', marginBottom: 12, fontSize: 14 }}>📁 파일 보관 정책</h4>
        <div style={{ fontSize: 13, color: '#6B7280', lineHeight: 2 }}>
          <div>• 원본 영상: 편집 완료 후 자동 삭제</div>
          <div>• 편집 영상 / 숏폼: 생성 후 7일 보관</div>
          <div>• 7일 후 파일은 자동으로 삭제됩니다</div>
          <div>• 삭제 전 반드시 다운로드 해주세요</div>
        </div>
      </div>
    </div>
  );
}
